import axios from 'axios';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { createCurrentProductsEndpointV5 } from '@/src/constants/endpoints';
import { CurrentProductsResponseV5 } from '@/src/types/Products';

type QueryCacheKey = 'orion-current-products-v5';

export const useCurrentProductsQuery = (
  options?: UseQueryOptions<
    CurrentProductsResponseV5,
    unknown,
    CurrentProductsResponseV5,
    QueryCacheKey
  >,
): UseQueryResult<CurrentProductsResponseV5> =>
  useQuery(
    'orion-current-products-v5',
    () =>
      axios
        .get<CurrentProductsResponseV5>(createCurrentProductsEndpointV5())
        .then(response => response.data),
    // A failed lookup falls back to the catalogue's first match, so retrying
    // would only delay the page.
    {
      staleTime: 5 * 60 * 1000,
      retry: false,
      ...options,
    },
  );
